const tools = require('../../tools')

exports.listWarehouseCodes = function (state, locationDoc) {
  const prefix = tools.getPSMCodePrefix(locationDoc.location.id)
  return state.dal.location.listWarehouseCodes(state, prefix)
}
